import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchReviews } from "../../../redux/reviewSlice";
import { Container, Row, Col, Card, Button, Spinner, Form } from "react-bootstrap";
import StarRating from "../../common/StarRating/StarRating";
import CustomerReview from "../../common/CustomerReview/CustomerReview";
import Star from "../../common/Star/Star";
const ReviewList = ({ productId }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [selectedRating, setSelectedRating] = useState(0);
  const dispatch = useDispatch();
  const { reviews, loading, error, message, totalReviews, totalPages, currentPage } = useSelector((state) => state.review);

  if (process.env.NODE_ENV === "development") {
    console.log("productId - aa gya product id", productId, selectedRating)
    console.log("reviews", reviews);
  }

  useEffect(() => {
    dispatch(fetchReviews({ productId, rating: selectedRating }));
  }, [dispatch, productId, selectedRating]);

  // const handleFetchReviews = useCallback(async (productId, selectedRating) => {
  //   try {
  //     await dispatch(fetchReviews({ productId, selectedRating }));
  //   } catch (error) {
  //     console.error("Error fetching reviews:", error);
  //   }
  // }, [dispatch, productId, selectedRating]);

  return (
    <>
      <Container>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
            <CustomerReview
              rating_5={reviews.filter(review => review.rating === 5).length}
              rating_4={reviews.filter(review => review.rating === 4).length}
              rating_3={reviews.filter(review => review.rating === 3).length}
              rating_2={reviews.filter(review => review.rating === 2).length}
              rating_1={reviews.filter(review => review.rating === 1).length}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12} className="mb-3">
            <Form.Select onChange={(e) => setSelectedRating(e.target.value)}>
              <option value="">All Ratings</option>
              <option value="5">5 Stars</option>
              <option value="4">4 Stars</option>
              <option value="3">3 Stars</option>
              <option value="2">2 Stars</option>
              <option value="1">1 Star</option>
            </Form.Select>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            {loading && <Spinner animation="border" />}
            {error && <p className="text-danger">{error}</p>}
            {reviews && reviews.length === 0 && <p>No reviews found.</p>}
          </Col>
          {reviews && reviews.map((review) => (

            <Col key={review._id} lg={4}>
              {/* {JSON.stringify(review)} */}
              <Card key={review._id} className="mb-3">
                <Card.Body>
                  {/* <Card.Title>{review.userId.name} - {review.rating} <StarRating defaultRating={review.rating} size={25} onSetRating={review.rating} />  </Card.Title> */}
                  <Card.Title>{review.userId.name}
                    {/* <StarRating defaultRating={review.rating} size={25} onSetRating={review.rating} /> */}
                    <Star value={review.rating} />
                  </Card.Title>
                  <Card.Text>{review.review} 11</Card.Text>
                  <ul className="review-images">
                    {review && review?.images.map((img) =>
                      <li>
                        <img src={`${apiUrl}${img}`} />
                      </li>
                    )}
                  </ul>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container >
    </>
  );
};

export default ReviewList;
